module.exports = __webpack_public_path__ + "static/media/washington-dc-19.02448d01.jpg";